import Desktop from "@/components/Desktop";
import {
	checkFetchStatus, tempDataPage
} from "./commonMobile";

//Todo: bind this function to desktop & mobile
function fetchNews(this: Desktop) {
	const
		{ useTempData } = this.state,
		request = (useTempData) ?
			new Request(tempDataPage + "?page=news") :
			new Request("/games/news");

	let init;
	if (!useTempData)
		init = { credentials: "same-origin" };

	// Fetch news
	fetch(request, init)
		.then(res => res.json())
		.then(news => {
			//Checks for idle
			if (!useTempData)
				checkFetchStatus(news);

			this.setState({ news });
		})
		.catch(error =>
			// alert("Failed to fetch news data, please try again later.");
			console.error("Failed to fetch news data", error)
		);
}

export {
	fetchNews
};
